import { motion } from "framer-motion";
import { CRAFT_IMG_1, CRAFT_IMG_2 } from "@/data/content";
import { easeOutExpo, fadeUp } from "@/lib/motion";

const STEPS = [
  { n: "01", t: "Curate the design", d: "Pick the occasion, palette and budget — we sketch it together." },
  { n: "02", t: "Personalize & engrave", d: "Names, logos, handwritten notes — printed, painted or etched." },
  { n: "03", t: "Hand-pack with love", d: "Ribbon, tissue and a wax seal — every box finished by hand." },
  { n: "04", t: "Doorstep delivery", d: "Safe, express, pan-India — tracked till it reaches the smile." },
];

export default function Craft() {
  return (
    <section className="py-16 md:py-24 lg:py-28" data-testid="craft-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <motion.div {...fadeUp} className="lg:col-span-5 relative">
            <div className="rounded-2xl overflow-hidden border border-gold/30 shadow-[0_40px_90px_-40px_rgba(26,21,18,0.45)]">
              <img src={CRAFT_IMG_1} alt="Artisan hand-painting wooden crafts" className="img-warm w-full h-72 sm:h-96 object-cover" loading="lazy" data-testid="craft-image-1" />
            </div>
            <div className="hidden sm:block absolute -bottom-10 -right-6 w-40 rotate-[4deg] rounded-2xl overflow-hidden border-4 border-ivory shadow-[0_30px_60px_-25px_rgba(26,21,18,0.5)]">
              <img src={CRAFT_IMG_2} alt="Handmade paper crafts with gold scissors" className="img-warm w-full h-40 object-cover" loading="lazy" data-testid="craft-image-2" />
            </div>
          </motion.div>

          <div className="lg:col-span-7">
            <motion.div {...fadeUp}>
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-crimson" data-testid="craft-eyebrow">
                The Atelier Process
              </p>
              <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-charcoal" data-testid="craft-heading">
                Made by hand, <span className="italic text-terracotta">made for you</span>
              </h2>
            </motion.div>

            <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-8">
              {STEPS.map((s, i) => (
                <motion.div
                  key={s.n}
                  {...fadeUp}
                  transition={{ ...fadeUp.transition, delay: 0.08 * i }}
                  className="border-t border-gold/30 pt-5"
                  data-testid={`craft-step-${i + 1}`}
                >
                  <p className="font-mono text-xs text-gold">{s.n}</p>
                  <h3 className="mt-2 font-display text-2xl font-semibold text-charcoal">{s.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-clay">{s.d}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
